<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowRestrictedAccessPopup"  persistent max-width="35%" class="popup-scoring" id="close-label-popup">
                <v-card class="no-padding">
                    <v-card-title class="headline bg-color-primary restricted-title">
                        <span class="font-weight-light">{{text('api.summary.restricted.title')}}</span>
                        <span @click="gotoHomePage()" class="float-right restricted-title-icon">
                              <img alt="close icon" src="../../../assets/svg/material-icons-alternatives/Close_White.svg" width="24px" height="24px">
                        </span>
                    </v-card-title>
                    <v-card-text class="text-center no-padding">

                       <div class="restricted-text">{{text('api.summary.restricted.access')}}</div>

                    </v-card-text>
                    <v-card-actions class="text-center warning-actions">

                        <div class="continue">
                            <v-btn @click="gotoHomePage()" class="btn-evaluation">{{text('api.button.ok')}}</v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'RestrictedPopup',

        computed: {
            ...mapGetters({
                mustShowRestrictedAccessPopup: 'SummaryStore/getMustShowRestrictedAccessPopup',
            }),
        },
        methods: {

            gotoHomePage() {
                this.$store.commit('SummaryStore/setMustShowRestrictedAccessPopup', false);
                this.$router.push('/home');

            }
        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .popup-scoring {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                padding: 15px 40px;
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }


    .restricted-text {
        padding: 8%;
    }

    .continue {
        margin: 0 auto !important;
    }

    .card__text{
        color: $color-body-text;
        font-size: $font-size-default
    }

    .restricted-title {
        position: relative;
        // SMASSDEV - 1119
        font-size: $font-size-xl;
        // letter-spacing: $letter-spacing-xl;
        // word-spacing: $word-spacing-xl;
        // line-height: $line-height-xl;
    }

    .restricted-title-icon {
        position: absolute;
        right: 20px;
    }

    .btn-evaluation {
        margin-bottom: 20px !important;
    }

    .warning-actions {
        border-top: none !important;
       padding: 0 !important;
    }

    .restricted-title-icon:hover {
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/common/components/shared/RestrictedPopup.vue